(ns practitest.frontend.components2.dashboard.transforms.pie
  (:require [practitest.frontend.components2.dashboard.helpers :as h]
            [practitest.frontend.components2.dashboard.schema :as sc]))

(def number-of-top 15)
(def sum-by #(transduce (map %1) + 0 %2))
(def desc >)

(defn- prepare-data [{:chart/keys [data percentage-mode colors-palette x-values-map
                                   remove-empty-values]}]
  (let [total (sum-by second data)]
    (for [[label amount grouped-labels] data

          :when (if remove-empty-values
                  (pos? amount)
                  true)
          :let  [percent (h/calc-percent total amount)]]
      {:label      (str label ":")
       :label-ext  (if percentage-mode (str percent "%") amount)
       :show-label true
       :amount     amount
       :percent    percent
       :tooltip    label
       :color      (colors-palette label)
       :value      amount
       :url-params {:x-param (get x-values-map (keyword label) (or grouped-labels label))}})))

(defn- other-item [items]
  (let [grouped-labels (mapv first items)]
    [h/other-label (sum-by second items) grouped-labels]))

(defn- grouping-other [items]
  (let [[top other] (->> items
                         (sort-by second desc)
                         (split-at number-of-top))]
    (cond-> top
      (seq other) (conj (other-item other)))))

(defn transform
  {:malli/schema [:=> [:cat sc/PieChart]
                  sc/PieChartTransformed]}
  [chart]
  (-> chart
      (update :chart/data grouping-other)
      prepare-data
      (as-> data
            (sort-by :value desc data)
            (assoc chart :chart/data (vec data)))))
